import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box } from '@primer/components';
import { StatusLabel } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As previously mentioned, it has been required that a number of components be built to make the documentation better.
Here is quick breakdown of each one.`}</p>
    <h2>{`External Link`}</h2>
    <Box mb={2} mdxType="Box">
      <StatusLabel status="New" mdxType="StatusLabel" />
    </Box>
    <p>{`Useful for defining a link external of this site that will cause the browser to load a new page.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`Click <ExternalLink href="https://xedi.com">here</ExternalLink> to learn about an awesome EDI company!
`}</code></pre>
    <h2>{`Github Issue`}</h2>
    <Box mb={2} mdxType="Box">
      <StatusLabel status="New" mdxType="StatusLabel" />
    </Box>
    <p>{`Provides information about a specific Github Issue.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<GithubIssue issue-id="2" />
`}</code></pre>
    <p>{`Works well when combines with a `}<inlineCode parentName="p">{`<BorderBox></BorderBox>`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      